import { ref, shallowReadonly } from '@vue/composition-api';
import { PartialRobotChatConfig, RobotChatConfig, SetProjectType, GetProjectType, RobotChatConfigReturnType } from '../types';
import { cloneDeep, merge } from 'lodash';
import { IntentType } from '../dataType';
import { Intents } from '../util/const';

export const botAvatar = require('@/assets/ai-robot/root-chat.png');
const projectId = ref();
const config = ref<RobotChatConfig>();
// const intent = useStorage<IntentType | undefined>('robot.chat.intent', undefined);
const intent = ref<IntentType | undefined>(undefined);

const recommendActive = ref<boolean>(false);
if (intent.value && !Intents.includes(intent.value)) {
  intent.value = undefined;
}

const DEFAULT: RobotChatConfig = {
  sendMessage: (type, message) => {
    console.warn(`message${message}」is not send.`);
    throw new Error('请实现该函数');
  },
  i18nResolver: (key) => key,
  userInfo: () => {
    throw new Error('请实现该函数');
  }
};

export const useConfig = (cfg?: PartialRobotChatConfig): RobotChatConfigReturnType => {
  let value = config.value || cloneDeep(DEFAULT);
  if (cfg) {
    let sendMessage: RobotChatConfig['sendMessage'] | undefined = undefined;
    const { sendMessage: cfgSendMessage } = cfg;
    if (typeof cfgSendMessage === 'function' && value.sendMessage !== cfgSendMessage) {
      sendMessage = (type, message, params) => {
        params = params || {};
        !params.intent && (params.intent = intent.value) ;
        return cfgSendMessage(type, message, params);
      };
    }
    value = merge({}, value, cfg, { sendMessage });
  }

  config.value = value;
  return {
    ...config.value,
    setIntent: (value) => {
      intent.value = value;
      recommendActive.value = false;
    },
    setRecommendActive: (value) => {
      recommendActive.value = value;
    },
    intent: shallowReadonly(intent),
    recommendActive: shallowReadonly(recommendActive),
    getUserInfo: () => {
      if (typeof config.value!.userInfo === 'function') {
        return config.value!.userInfo();
      }
      return config.value!.userInfo;
    }
  };
};

export const useAutomationConfig = () => {
  const setAutomationProject: SetProjectType = (v: number | null) => {
    projectId.value = v;
  };
  const getAutomationProject: GetProjectType = () => {
    return projectId.value;
  };

  return {
    setAutomationProject,
    getAutomationProject
  };
};
